import { Injectable } from '@angular/core';

const TOKEN_KEY = 'Uad-Token';
const REFRESH_TOKEN = 'Refresh-Token'

@Injectable()
export class TokenStorage {


  save(token: any) {
    window.localStorage[TOKEN_KEY] = token;
  }

  get() {
    if (window.localStorage[TOKEN_KEY]) {
      return window.localStorage[TOKEN_KEY];
    } else {
      return ''
    }
  }
  getToken() {
    return window.localStorage.getItem(TOKEN_KEY) || '';
  }
  destroy() {
    window.localStorage.removeItem(TOKEN_KEY);
  }
  saveRT(token: any) {
    window.localStorage[REFRESH_TOKEN] = token;
  }
  getRT() {
    if (window.localStorage[REFRESH_TOKEN]) {
      return window.localStorage[REFRESH_TOKEN];
    } else {
      return ''
    }
  }
  destroyRT() {
    window.localStorage.removeItem(REFRESH_TOKEN);
  }
}
